import React, { useContext } from 'react';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import styled from "styled-components";
import { GlobalMessageContext } from "../context/GlobalMessage";


const Wrapper = styled(Toast)`
  border: 2px rgba(${({variant}) => variantEnums.getVariant(variant)}, 0.5) solid;
  border-radius: 5px;
  background-color: rgba(255,255,255, 0.9);
  
`

const variantEnums = {
    "info": "50,50,50",
    "error": "255,0,0",
    "success": "0,155,0",
    "warn": "200,150,0",
    getVariant(variant) {
        if (this.hasOwnProperty(variant)) return this[variant]
        return this.info // default
    }
}



export function AlertToast({ position }) {
    const hooks = useContext(GlobalMessageContext)
    return (
        <div
            aria-live="polite"
            aria-atomic="true"
            style={{zIndex: 10000}}
        >
            <ToastContainer style={{ marginTop: "70px" }} position={"top-center"} className="p-3">
                <ul>
                    {hooks.notification.map(notification => (
                        <li>
                            <Component
                                title={notification.title}
                                context={notification.context}
                                text={notification.text}
                                show={hooks.show}
                                setShow={hooks.setShow}
                            />
                        </li>
                    ))}
                </ul>
            </ToastContainer>
        </div>
    );
}

const Component = ({title, context, text, show, setShow}) => {

    return (
        <Wrapper variant={context} onClose={() => setShow(false)} show={show} delay={7000} autohide>
            <Toast.Header>
                <img
                    src="holder.js/20x20?text=%20"
                    className="rounded me-2"
                    alt=""
                />
                <strong className="me-auto">{title}</strong>
                <small className="text-muted">{context}</small>
            </Toast.Header>
            <Toast.Body>{text}</Toast.Body>
        </Wrapper>
    )
}